import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {ChangesContext, ToastContext} from "../Contexts";
import {
    ListItemCreateRequest,
    ListItemResponse,
    ToastFailureMessage,
    ToastSuccessMessage
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function ListItemService() {
    const navigate = useNavigate()
    let {setToast}: any = useContext(ToastContext);
    let { setHasChanges } : any = useContext(ChangesContext);

    async function getListItem(id: number): Promise<ListItemResponse> {
        try {
            return (await HttpRepository.getListItem(id)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function createListItem(request: ListItemCreateRequest): Promise<void> {
        try {
            await HttpRepository.createListItem(request);
            setHasChanges(true);
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});
        navigateToListTable();
    }

    async function updateListItem(request: ListItemResponse): Promise<void> {
        try {
            await HttpRepository.updateListItem(request);
            setHasChanges(true);
        } catch (error) {
            setToast({message: ToastFailureMessage.changesNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});
        navigateToListTable();
    }

    async function deleteListItem(id: number): Promise<void> {
        try {
            await HttpRepository.deleteListItem(id);
            setHasChanges(true);
            setToast({message: ToastSuccessMessage.changesSaved});
            navigateToListTable();
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotSaved});
        }
    }

    const navigateToListTable = () => {
        navigate("/list/table");
    };

    return {getListItem, createListItem, updateListItem, deleteListItem}
}